// Notification.tsx
import React, { useEffect } from 'react';
import Box from '@mui/material/Box';

export interface NotificationProps {
  open: boolean;
  message: string;
  severity: 'success' | 'info' | 'warning' | 'error';
  onClose: () => void;
}

const getBackgroundColor = (severity: NotificationProps['severity']) => {
  switch (severity) {
    case 'success':
      return '#4caf50';
    case 'info':
      return '#2196f3';
    case 'warning':
      return '#ff9800';
    case 'error':
      return '#f44336';
    default:
      return '#2196f3';
  }
};

const Notification: React.FC<NotificationProps> = ({
  open,
  message = 'Something went wrong',
  severity = 'error',
  onClose,
}) => {
  useEffect(() => {
    setTimeout(() => onClose(), 3000);
  }, []);
  if (!open) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 16,
        right: 16,
        minWidth: '300px',
        padding: '16px',
        borderRadius: '4px',
        backgroundColor: getBackgroundColor(severity),
        color: '#fff',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        zIndex: 999999,
        cursor: 'pointer',
      }}
      onClick={onClose}
    >
      {message}
    </Box>
  );
};

export default Notification;
